export const BASE_MAPPING_URL = 'v4/media.vkplay.ru/games_map/';

export const ERROR_MESSAGES = {
    400: 'Эта игра уже имеет связь.',
    404: 'Игра не найдена.',
};
